import { render, staticRenderFns } from "./QueenNew.vue?vue&type=template&id=6961e559&scoped=true&"
import script from "./QueenNew.vue?vue&type=script&lang=js&"
export * from "./QueenNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6961e559",
  null
  
)

export default component.exports